
export default [
  // Guest Routes
  {
    path: '/login',
    name: 'login.index',
    component: () => import('@/pages/Login/Index'),

    // If the user needs to be a guest to view this page.
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/inquiry-tender/reply/:code/:type?',
    name: 'inquiry-tender-reply',
    component: () => import('@/pages/Guest/InquiryReply'),
  },

  {
    path: '/survey/:hash',
    name: 'survey',
    component: () => import('@/pages/Guest/Survey'),
  },

  {
    path: '/article-inquiry/reply/:code/:type?',
    name: 'article-inquiry-reply',
    component: () => import('@/pages/Guest/ArticleInquiryReply'),
  },

  {
    path: '/article-inquiry/reject/:code/:type?',
    name: 'article-inquiry-reject',
    component: () => import('@/pages/Guest/ArticleInquiryReply'),
    meta: {
      reject: true,
    },
  },
  {
    path: '/handover-poll/reply/:token',
    name: 'handover-poll-reply',
    component: () => import('@/pages/Guest/HandoverReplyPollForm'),
  },
  {
    path: '/',
    redirect: '/home',
  },

  {
    path: '/*',
    name: 'not-found',
    component: () => import('@/pages/Errors/404'),
  },
];



// WEBPACK FOOTER //
// ./src/routes/guest.js